import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useP9301Query } from './hooks/useP9301Query';
import { useP9301Permissions } from './hooks/useP9301Permissions';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import FilterPanel from './components/FilterPanel';
import ResultTable from './components/ResultTable';
import ActionBar from './components/ActionBar';
import './P9301Form.css';

const P9301Form: React.FC = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _perms = useP9301Permissions();

  const {
    filters,
    setFilter,
    resetFilters,
    handleEmpFromBlur,
    handleDeptFromBlur,
    results,
    count,
    loading,
    queried,
    executeQuery,
  } = useP9301Query();

  /** Print handler — uses window.print() */
  const handlePrint = useCallback(() => {
    window.print();
  }, []);

  return (
    <PermissionGuard module={Modules.P9301} action="query">
    <div className="p9301-form">
      {loading && <div className="loading-overlay">查詢中...</div>}

      <div className="page-wrapper">
        {/* Page Title Bar */}
        <div className="page-title-bar">
          <div className="page-title-left">
            <nav className="breadcrumb-inline">
              <a href="#/erp" onClick={e => { e.preventDefault(); navigate('/erp'); }}>首頁</a>
              <span>/</span>
              <a href="#/erp" onClick={e => { e.preventDefault(); navigate('/erp'); }}>人事管理</a>
              <span>/</span>
              <span className="current">員工資料表列印查詢</span>
            </nav>
            <span className="title-separator">--</span>
            <h1>員工資料表列印查詢</h1>
            <span className="badge badge-default">PW9301</span>
          </div>
        </div>

        {/* Filter Panel */}
        <FilterPanel
          filters={filters}
          loading={loading}
          onFilterChange={setFilter}
          onEmpFromBlur={handleEmpFromBlur}
          onDeptFromBlur={handleDeptFromBlur}
          onQuery={executeQuery}
          onReset={resetFilters}
        />

        {/* Query Results Table */}
        <ResultTable
          results={results}
          count={count}
          queried={queried}
        />

        {/* Bottom Action Bar */}
        <ActionBar
          hasResults={results.length > 0}
          onPrint={handlePrint}
          onExit={() => navigate('/erp')}
        />
      </div>
    </div>
    </PermissionGuard>
  );
};

export default P9301Form;
